import { parse } from 'url';

import React from 'react';
import Box from '@sizeid/commons/components/Box';
import { nlBr } from '@sizeid/commons/utils/strings';
import { NextPage, NextPageContext } from 'next';
import { WithTranslation } from 'next-i18next';

import app from 'components/app';
import P from 'components/typo/P';
import Page, { Section, Wrapper } from 'components/Page';
import WhiteBox from 'components/WhiteBox';
import { H1 } from 'components/typo/Heading';
import { Router, useTranslation } from 'lib/i18n';
import ForgottenPasswordRequestForm from 'containers/ForgottenPasswordRequestForm';
import { AppProps } from 'components/app/types';

import { headerCss, sectionStyle, signFormsBoxStyle } from '../sign/styles';

import { textCss } from './styles';
import {
  ForgottenPasswordRequestProps,
  ForgottenPasswordRequestInitialProps,
} from './types';
import BackToSign from './BackToSign';

const renderContent = (
  props: ForgottenPasswordRequestProps & WithTranslation,
): JSX.Element => (
  <>
    <Box css={signFormsBoxStyle(props.advisor)}>
      <H1 css={headerCss}>{props.t('forgottenPassword.request.header')}</H1>
      <WhiteBox contentPadding>
        <P css={textCss}>{nlBr(props.t('forgottenPassword.request.text'))}</P>
        <ForgottenPasswordRequestForm />
      </WhiteBox>
    </Box>
    <BackToSign {...props} />
  </>
);

const ForgottenPasswordRequest: NextPage<
  AppProps & ForgottenPasswordRequestInitialProps,
  ForgottenPasswordRequestInitialProps
> = props => {
  const { t, i18n, ready } = useTranslation('pages');

  const renderContentProps = { ...props, t, i18n, tReady: ready };

  return props.advisor ? (
    renderContent(renderContentProps)
  ) : (
    <Page
      title={t('forgottenPassword.request.title')}
      footer
      noHeader
      noPadding
    >
      <Section css={sectionStyle}>
        <Wrapper>{renderContent(renderContentProps)}</Wrapper>
      </Section>
    </Page>
  );
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
ForgottenPasswordRequest.getInitialProps = async (
  context: NextPageContext,
): Promise<ForgottenPasswordRequestInitialProps> => {
  const url = context.req ? parse(`${context.req.url}`, true) : Router;
  return {
    advisor: url && url.query && 'advisor' in url.query,
  };
};

export default app(ForgottenPasswordRequest);
